import { yupResolver } from "@hookform/resolvers/yup";
import { OrderItemFormValues } from "./types";
import { schema } from "./constants";
import { FormProvider, useForm } from "react-hook-form";

export interface OrderItemFormProviderProps {
  defaultFormValues?: Partial<OrderItemFormValues>;
  children?: React.ReactNode;
}

export const OrderItemFormProvider = ({
  defaultFormValues,
  children,
}: OrderItemFormProviderProps) => {
  const methods = useForm<OrderItemFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  // Register all the fields so that we can use them in the form
  // without hook form spazzing out
  methods.register("barcode");
  methods.register("name");
  methods.register("productId");
  methods.register("stockOrderId");
  methods.register("quantity");
  methods.register("supplierCode");
  methods.register("supplierId");
  methods.register("id");

  return <FormProvider {...methods}>{children}</FormProvider>;
};
